import React from "react";
import { BaseModal } from "./BaseModal";
import { useStore } from "../../stores/store";
import { ModalKeys } from "../../interfaces/config";

export default function ResetUserPasswordConfirmationModal() {
  const { isActive, deactivateTool, adminModalUser, resetUserPassword } =
    useStore();
  const [successAlertShown, setSuccessAlertShown] = React.useState(false);
  return (
    <>
      <BaseModal
        active={isActive(ModalKeys.RESET_USER_PASSWORD_CONFIRMATION)}
        title="Reset User Password"
      >
        <div className="p-3 font-helvetica text-sm">
          <p>
            Are you sure you want to reset the password for{" "}
            <span className="text-blue-600">{adminModalUser?.UserName}</span>?
          </p>
        </div>
        <div className="bg-[#f5f5f5] border-t border-[#ddd] w-full text-right p-1">
          <button
            onClick={() => {
              resetUserPassword(adminModalUser?.Id);
              deactivateTool(ModalKeys.RESET_USER_PASSWORD_CONFIRMATION);
              setSuccessAlertShown(true);
              setTimeout(() => {
                setSuccessAlertShown(false);
              }, 5000);
            }}
            className="btn-athena btn-sm mr-1"
          >
            Reset User Password
          </button>
          <button
            onClick={() => {
              deactivateTool(ModalKeys.RESET_USER_PASSWORD_CONFIRMATION);
            }}
            className="btn-athena btn-sm"
          >
            Cancel
          </button>
        </div>
      </BaseModal>
      {successAlertShown && (
        <div className="absolute top-0 w-full text-center transition-all">
          <div role="alert" className="alert alert-success w-96 m-auto">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-6 w-6 shrink-0 stroke-current"
              fill="none"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
              />
            </svg>
            <span>
              Successfully reset password for: {adminModalUser?.UserName}
            </span>
          </div>
        </div>
      )}
    </>
  );
}
